import { render, staticRenderFns } from "./knowledgeSearchPage.vue?vue&type=template&id=9ca80b26&scoped=true"
import script from "./knowledgeSearchPage.vue?vue&type=script&lang=js"
export * from "./knowledgeSearchPage.vue?vue&type=script&lang=js"
import style0 from "./knowledgeSearchPage.vue?vue&type=style&index=0&id=9ca80b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca80b26",
  null
  
)

export default component.exports